module.exports = __webpack_public_path__ + "img/credit-card (2).fd63806f.svg";